export default __webpack_public_path__ + "assets/omhmLogo.png";